import { Navigate, Route, Routes } from 'react-router-dom';

import { SearchView } from './search.view';

export const SearchRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route index element={<Navigate to="conversations" replace />} />

      <Route
        path="contacts"
        element={<Navigate to="/search/users" replace />}
      />

      <Route path=":scope" element={<SearchView />} />
    </Routes>
  );
};
